/** Available sort by keys for the widgets API endpoint. */
export var WigetSortKey;
(function (WigetSortKey) {
    WigetSortKey["CreatedAt"] = "created_at";
    WigetSortKey["Id"] = "id";
    WigetSortKey["Name"] = "name";
    WigetSortKey["UpdatedAt"] = "updated_at";
})(WigetSortKey || (WigetSortKey = {}));
